import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login, apiError } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(apiError(err));
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-[#F3EFEA] border border-[#2C4A3E]/12 rounded-2xl p-8 shadow-sm">
        <div className="flex justify-center mb-4">
          <span className="w-12 h-12 rounded-full bg-[#2C4A3E] flex items-center justify-center">
            <Leaf className="w-6 h-6 text-[#E8ECE8]" />
          </span>
        </div>
        <h1 className="font-serif text-3xl text-center text-[#1A2621]">Welcome back</h1>
        <p className="text-center text-sm text-[#5A6B61] mt-1">Continue your herbal studies</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#2C4A3E] mb-1">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-[#2C4A3E]/20 bg-white/70 focus:outline-none focus:border-[#2C4A3E]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#2C4A3E] mb-1">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-[#2C4A3E]/20 bg-white/70 focus:outline-none focus:border-[#2C4A3E]" />
          </div>
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full py-3 rounded-xl bg-[#2C4A3E] text-[#FAF8F5] font-semibold hover:bg-[#223B31] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Log in"}
          </button>
        </form>
        <p className="text-center text-sm text-[#5A6B61] mt-5">
          New here?{" "}
          <Link to="/register" data-testid="go-register" className="text-[#2C4A3E] font-semibold underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
